import { driver } from 'driver.js'

const preferedTheme = () => {
    const selectedTheme = localStorage.getItem( "preferedTheme" ) || 'light'
    if ( selectedTheme === 'system' ) {
        if ( window.matchMedia && window.matchMedia( '(prefers-color-scheme: dark)' ).matches ) {
            return 'dark'
        } else if ( window.matchMedia && window.matchMedia( '(prefers-color-scheme: light)' ).matches ) {
            return 'light'
        } else {
            return 'light'
        }
    } else
        return selectedTheme
}

export const practiceSessionCreateDrive = driver( {
    overlayOpacity: 0.7,
    showProgress: true,
    smoothScroll: true,
    showButtons: ["close", "next"],
    disableButtons: ["previous"],
    stagePadding: 5,
    popoverClass: `custom-driver-popover custom-driver-popover_${preferedTheme()}`,
    steps: [
        {
            element: '#fab-for-create',
            scrollIntoViewOptions: { behavior: "smooth", block: "center" },
            popover: {
                title: 'Initialize Session',
                description: 'Click this button to launch the configuration form for a new practice session.',
                side: "left",
                align: 'start',
                onNextClick: async () => {
                    const element = document.getElementById( "fab-for-create" )
                    element?.click()
                    await new Promise( res => setTimeout( res, 100 ) ) // Increased for smoother transition
                    practiceSessionCreateDrive.moveNext()
                },
            }
        },
        {
            element: '#createPracticeSessionFormControlForTitle',
            popover: {
                title: 'Session Title',
                description: 'Assign a concise and descriptive title. This will be used as the primary identifier during searches.',
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: '#createPracticeSessionFormControlForAcYear',
            popover: {
                title: 'Academic Period',
                description: 'Select the relevant academic year. The system automatically defaults to the most recent term.',
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: '#academicYearRefreshBtn',
            popover: {
                title: 'Synchronize Data',
                description: 'Use the refresh utility to fetch newly updated academic terms if they do not appear in the list.',
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: '#createPracticeSessionFormControlForSubject',
            popover: {
                title: 'Subject Assignment',
                description: 'Choose the specific subject curriculum that this practice session will support.',
                side: "bottom",
                align: 'start',
                onNextClick: async () => {
                    const element = document.getElementById( "subjectSelector" )
                    element.dispatchEvent( new MouseEvent( 'mousedown', { view: window, bubbles: true, cancelable: true } ) )
                    element?.click()
                    await new Promise( res => setTimeout( res, 250 ) )
                    document.getElementById( `subject-option-0` )?.click()
                    await new Promise( res => setTimeout( res, 100 ) )
                    practiceSessionCreateDrive.moveNext()
                }
            }
        },
        {
            element: '#createPracticeSessionFormControlForStudentGroups',
            popover: {
                title: 'Target Cohorts',
                description: 'Select the batches or sections to which this session should be distributed.',
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: '#moduleAdder',
            popover: {
                title: 'Curriculum Mapping',
                description: 'Map this session to the appropriate module (Modules 1–5) within the syllabus.',
                side: "bottom",
                align: 'start',
                onNextClick: async ( element ) => {
                    element.dispatchEvent( new MouseEvent( 'mousedown', { view: window, bubbles: true, cancelable: true } ) )
                    element?.click()
                    await new Promise( res => setTimeout( res, 250 ) )
                    document.getElementById( "Module 1" )?.click()
                    await new Promise( res => setTimeout( res, 200 ) )
                    practiceSessionCreateDrive.moveNext()
                },
            }
        },
        {
            element: '#createPracticeSessionFormControlForDateRange',
            popover: {
                title: 'Coverage Timeline',
                description: 'Define the date range during which the selected course topics were instructed.',
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: '#createPracticeSessionFormControlForModuleName',
            popover: {
                title: 'Module Identification',
                description: 'Specify the formal name of the module (e.g., "Principles of Neural Networks").',
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: '#createPracticeSessionFormControlForModuleTopics',
            popover: {
                title: 'Topic Specification',
                description: 'Input the specific topics covered. Press ENTER or click "Add" to register each individual item.',
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: '#createPracticeSessionFormControlForCloseDate',
            popover: {
                title: 'Set Time Window for Practice',
                description: "You can optionally set a close date so students won't be able to start practice after this date.",
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: '#practiceSessionCreateSubmitBtn',
            popover: {
                title: 'Finalize and Publish',
                description: 'Review your entries and click "Create" to finalize the session deployment.',
                side: "bottom",
                align: 'start'
            }
        },
    ]
} )